/* ============================================
   CUIDA TU SALUD AL NATURAL — THEME JS
   ============================================ */

'use strict';

// =========================================
// UTILS
// =========================================
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function on(el, event, fn, opts) {
  if (!el) return;
  el.addEventListener(event, fn, opts);
}

// =========================================
// HEADER — sticky + scroll class
// =========================================
(function initHeader() {
  const header = $('#site-header');
  if (!header) return;
  let last = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 20);
    last = y;
  }, { passive: true });
})();

// =========================================
// MOBILE NAV
// =========================================
(function initMobileNav() {
  const toggle  = $('#nav-toggle');
  const nav     = $('#mobile-nav');
  const close   = $('#mobile-nav-close');
  const overlay = $('#mobile-nav-overlay');
  if (!toggle || !nav) return;

  function openNav() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  on(toggle, 'click', openNav);
  on(close, 'click', closeNav);
  on(overlay, 'click', closeNav);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeNav(); });
})();

// =========================================
// SEARCH MODAL
// =========================================
(function initSearch() {
  const trigger = $('#search-trigger');
  const modal   = $('#search-modal');
  const close   = modal ? $('.search-modal__close', modal) : null;
  const overlay = modal ? $('.search-modal__overlay', modal) : null;
  const input   = modal ? $('.search-modal__input', modal)   : null;
  if (!trigger || !modal) return;

  function openSearch() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input && input.focus(), 100);
  }
  function closeSearch() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  on(trigger, 'click', openSearch);
  on(close, 'click', closeSearch);
  on(overlay, 'click', closeSearch);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSearch(); });
})();

// =========================================
// SLIDESHOW
// =========================================
(function initSlideshows() {
  $$('.slideshow').forEach(slideshow => {
    const track    = $('.slideshow__track', slideshow);
    const dots     = $$('.slideshow__dot', slideshow);
    const prevBtn  = $('.slideshow__nav--prev', slideshow);
    const nextBtn  = $('.slideshow__nav--next', slideshow);
    const slides   = $$('.slideshow__slide', track || slideshow);

    if (!track || slides.length < 2) return;

    const autoplay = slideshow.dataset.autoplay !== 'false';
    const speed    = (parseInt(slideshow.dataset.speed, 10) || 5) * 1000;
    let current    = 0;
    let timer      = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startTimer() {
      if (!autoplay) return;
      timer = setInterval(next, speed);
    }
    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    on(prevBtn, 'click', () => { prev(); resetTimer(); });
    on(nextBtn, 'click', () => { next(); resetTimer(); });

    dots.forEach((dot, i) => {
      on(dot, 'click', () => { goTo(i); resetTimer(); });
    });

    // Swipe / drag support
    let startX = 0;
    on(slideshow, 'touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    on(slideshow, 'touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? next() : prev(); resetTimer(); }
    });

    // Pause on hover
    on(slideshow, 'mouseenter', () => clearInterval(timer));
    on(slideshow, 'mouseleave', startTimer);

    startTimer();
  });
})();

// =========================================
// CART DRAWER
// =========================================
const CartDrawer = (function() {
  const drawer  = $('#cart-drawer');
  const trigger = $('#cart-trigger');
  const closeBtn = drawer ? $('.cart-drawer__close', drawer) : null;
  const overlay  = drawer ? $('.cart-drawer__overlay', drawer) : null;
  const itemsCtr = $('#cart-drawer__items');
  const subtotalEl = $('#cart-subtotal');
  const countEl = $('#cart-count');

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderItems(cart) {
    if (!itemsCtr) return;
    if (cart.items.length === 0) {
      itemsCtr.innerHTML = '<p style="text-align:center;padding:40px;color:#888;">Tu carrito está vacío</p>';
      return;
    }
    itemsCtr.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.title}" width="64" height="64" style="width:64px;height:64px;object-fit:cover;border-radius:8px;">
        <div style="flex:1;min-width:0;">
          <div style="font-size:.9rem;font-weight:600;color:#1a2e24;line-height:1.3;">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:.75rem;color:#888;">${item.variant_title}</div>` : ''}
          <div style="display:flex;align-items:center;gap:12px;margin-top:8px;">
            <div style="display:flex;align-items:center;border:1px solid #e0e8e0;border-radius:6px;overflow:hidden;">
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" style="padding:4px 10px;font-size:.9rem;">−</button>
              <span style="padding:4px 10px;font-size:.875rem;">${item.quantity}</span>
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" style="padding:4px 10px;font-size:.9rem;">+</button>
            </div>
            <span style="font-weight:700;color:#2d6a4f;">${formatMoney(item.line_price)}</span>
          </div>
        </div>
        <button class="remove-item" data-key="${item.key}" style="color:#aaa;padding:4px;" aria-label="Eliminar">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M10 4L4 10M4 4l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
        </button>
      </div>
    `).join('');

    // Qty buttons
    $$('.qty-btn', itemsCtr).forEach(btn => {
      on(btn, 'click', () => updateItem(btn.dataset.key, parseInt(btn.dataset.qty, 10)));
    });
    $$('.remove-item', itemsCtr).forEach(btn => {
      on(btn, 'click', () => updateItem(btn.dataset.key, 0));
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function updateCount(count) {
    if (!countEl) return;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
  }

  async function fetchCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      renderItems(cart);
      updateCount(cart.item_count);
    } catch(e) {
      console.error('Cart fetch error:', e);
    }
  }

  async function updateItem(key, qty) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      renderItems(cart);
      updateCount(cart.item_count);
    } catch(e) {
      console.error('Cart update error:', e);
    }
  }

  async function addItem(variantId, qty = 1) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      open();
    } catch(e) {
      console.error('Add to cart error:', e);
    }
  }

  // Init
  on(trigger, 'click', open);
  on(closeBtn, 'click', close);
  on(overlay, 'click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  // ATC buttons (delegated)
  document.addEventListener('click', e => {
    const btn = e.target.closest('.product-card__atc');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.textContent = 'Agregando…';
    btn.disabled = true;
    addItem(variantId).then(() => {
      btn.textContent = '¡Agregado!';
      setTimeout(() => {
        btn.textContent = 'Agregar al carrito';
        btn.disabled = false;
      }, 2000);
    });
  });

  return { open, close, addItem, fetchCart };
})();

// Style cart items
const style = document.createElement('style');
style.textContent = `
  .cart-item { display:flex; gap:12px; padding:12px 0; border-bottom:1px solid #f0f4f0; align-items:flex-start; }
  .cart-item:last-child { border-bottom:none; }
`;
document.head.appendChild(style);

// =========================================
// TESTIMONIALS CAROUSEL (mobile)
// =========================================
(function initTestimonials() {
  $$('.testimonials__carousel').forEach(carousel => {
    const track = $('.testimonials__track', carousel);
    const prevBtn = $('.testimonials__btn--prev', carousel);
    const nextBtn = $('.testimonials__btn--next', carousel);
    if (!track) return;

    let current = 0;
    const cards = $$('.testimonial-card', track);
    const visible = window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;

    if (cards.length <= visible) return;

    const cardW = cards[0] ? cards[0].offsetWidth + 20 : 0;

    function goTo(i) {
      current = Math.max(0, Math.min(i, cards.length - visible));
      track.style.transform = `translateX(-${current * cardW}px)`;
      track.style.transition = 'transform 0.4s ease';
    }

    on(prevBtn, 'click', () => goTo(current - 1));
    on(nextBtn, 'click', () => goTo(current + 1));
  });
})();

// =========================================
// SCROLL ANIMATIONS (IntersectionObserver)
// =========================================
(function initAnimations() {
  if (!('IntersectionObserver' in window)) return;

  const targets = $$('.product-card, .collection-card, .testimonial-card, .trust-bar__item, .stat-item');
  targets.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = `opacity 0.5s ease ${(i % 4) * 0.08}s, transform 0.5s ease ${(i % 4) * 0.08}s`;
  });

  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(el => obs.observe(el));
})();
